import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2l-2 0","key":"svg-0"}],["path",{"d":"M14 8h-4v8h4","key":"svg-1"}],["path",{"d":"M10 12h2.5","key":"svg-2"}],["path",{"d":"M17 8v8h4","key":"svg-3"}]]

const IconHttpDelete = createReactComponent('outline', 'http-delete', 'HttpDelete', __iconNode);

export default IconHttpDelete;